import { NewReviewerInvitationEmailRequestDto } from '@/models/Admin/Emails/EmailRequestDtos';
import { UserType } from '@/models/User';
import { isEmail } from '@/utils/emailUtil';
import React, { useEffect, useState } from 'react';
import NewReviewerInvitationForm from './NewReviewerInvitationForm';
import { NewReviewerInvitationSubmitState } from './types';

type Props = {
  onStateChange: React.Dispatch<React.SetStateAction<NewReviewerInvitationSubmitState>>;
  resetSignal: number;
};

const userTypeOptions = Object.values(UserType).filter(
  (value): value is UserType =>
    typeof value === 'number' && value !== UserType.Applicant && value !== UserType.Adf
);

const createInitialForm = (): NewReviewerInvitationEmailRequestDto => ({
  Email: '',
  UserRole: UserType.Applicant,
  FullName: '',
});

const createEmptySubmitState = (): NewReviewerInvitationSubmitState => ({
  request: createInitialForm(),
  isValid: false,
});

const NewReviewerInvitationSection: React.FC<Props> = ({ onStateChange, resetSignal }) => {
  const [form, setForm] = useState<NewReviewerInvitationEmailRequestDto>(createInitialForm());

  const isValid = isEmail(form.Email) && form.UserRole != null && form.FullName.trim() !== '';

  useEffect(() => {
    onStateChange({
      request: form,
      isValid,
    });
  }, [form, isValid, onStateChange]);

  useEffect(() => {
    setForm(createInitialForm());
    onStateChange(createEmptySubmitState());
  }, [onStateChange, resetSignal]);

  return (
    <NewReviewerInvitationForm form={form} setForm={setForm} userTypeOptions={userTypeOptions} />
  );
};

export default NewReviewerInvitationSection;
